import { createGlobalStyle } from "styled-components";

const GlobalStyles = createGlobalStyle`
  * {
    scrollbar-width: thin; /* Firefox */
    scrollbar-color: rgba(0, 0, 0, 0.25) transparent;
  }

  *::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }

  *::-webkit-scrollbar-track {
    background: transparent;
  }

  *::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, 0.25);
    border-radius: 20px;
    transition: background-color 0.3s ease, box-shadow 0.3s ease;
  }

  *::-webkit-scrollbar-thumb:hover {
    background-color: rgba(0, 0, 0, 0.25); /* same opacity */
    box-shadow: 0 0 4px rgba(0, 0, 0, 0.4); /* subtle glow instead of thickening */
  }
`;

export default GlobalStyles;
